import { OutgoingActions } from './persistent-iframe.constants';
import { getAppMetadata } from './persistent-iframe.app-metadata';
import config from 'src/globals';

const { IFRAME_NON_STRICT_MODE } = config;
const allMessageQueues: Record<string, any> = {};
const isAppLoaded: Record<string, boolean> = {};

const sendMessageToIframeWindow = (appName: string, message: string) => {
  const metadata = getAppMetadata(appName);
  if (!metadata) return;
  const frameId = metadata.iframeId;
  const origin = IFRAME_NON_STRICT_MODE ? '*' : metadata.origin;
  (window.frames[frameId as any] as any).contentWindow.postMessage(message, origin);
};

const checkIfAppLoaded = (appName: string) => {
  return isAppLoaded[appName] || false;
};

export const setAppLoaded = (appName: string) => {
  isAppLoaded[appName] = true;
};

export const sendMessage = (appName: string, message: string) => {
  if (checkIfAppLoaded(appName)) {
    sendMessageToIframeWindow(appName, message);
  } else {
    allMessageQueues[appName] = (allMessageQueues[appName] || []).concat(message);
  }
};

export const flushMessageQueue = (appName: string) => {
  const queue = allMessageQueues[appName] || [];
  queue.forEach((message: string) => {
    sendMessageToIframeWindow(appName, message);
  });
};

export const sendRoutingEvent = (appName: string, route: string) => {
  const stringifiedRoute = JSON.stringify({
    type: OutgoingActions.Routing,
    data: route,
  });
  sendMessage(appName, stringifiedRoute);
};

export const sendCredentials = (appName: string, credentials: any) => {
  const stringifiedCredentials = JSON.stringify({
    type: OutgoingActions.CREDENTIALS_SHARING,
    data: {
      ...credentials,
      'parent-url': window.location.href,
      'project-name': 'transporter-portal',
    },
  });
  sendMessage(appName, stringifiedCredentials);
};
